<!-- Shared layout for a dropdown item's icon, label, help text, and trailing addon slot. -->

<script lang="ts" setup>
import type { Component, VNodeChild } from 'vue';

import css from './Dropdown.module.scss';

interface Props {
  icon?: Component | null;
}

interface Slots {
  default: () => VNodeChild;
  addon: () => VNodeChild;
  help: () => VNodeChild;
}

defineProps<Props>();
defineSlots<Slots>();
</script>

<template>
  <div :class="css.content">
    <span
      v-if="icon"
      :class="css.icon"
    >
      <component :is="icon" />
    </span>

    <span :class="css.textWrapper">
      <span :class="css.text">
        <slot />
      </span>
      <span
        v-if="$slots.help"
        :class="css.help"
      >
        <slot name="help" />
      </span>
    </span>

    <slot name="addon" />
  </div>
</template>
